/**
 * Toolkit INIT ALL
 */

//
// Do not add any JS here, it's loaded in all the pages. Make a dynamic import. @see MATCH-3823
//

// Elements
import version from './_00_elements/tools/version/version';
import deviceDetect from './_00_elements/tools/device-detect';
import lazy from './_00_elements/tools/lazyloading';

// Atoms import
import loadAtoms from './_01_atoms/load-atoms';

// Molecules import
import banner from './_02_molecules/banner';
import favoriteBusHandler from './_02_molecules/favorite-bus-handler';
import proposalBusHandler from './_02_molecules/proposal-bus-handler';
import sliderManager from './_02_molecules/slider-manager';
import accordions from './_02_molecules/components/accordion';

// Organism import
import header from './_03_organisms/header';
import user from './_03_organisms/user';
import stickyHeader from './_03_organisms/sticky-header';

// Pages import
import profileManage from './_04_pages/profile-manage';
import contactUs from './_04_pages/contact-us';
import offerPage from './_04_pages/offer';
import createOffer from './_04_pages/create-offer';
import editOffer from './_04_pages/edit-offer';
import vueInit from './_04_pages/vue-init';
import offerFavorites from './_04_pages/offer/favorites';
import offerProposals from './_04_pages/offer/proposals';
import about from './_04_pages/about';
import inbox from './_04_pages/inbox';
import invoice from './_04_pages/invoice';
import dealDashboard from './_04_pages/deal-dashboard';
import leads from './_04_pages/leads';
import address from './_04_pages/address';
import addressContact from './_04_pages/address-contact';
import addressDetails from './_04_pages/address-details';
import adaf from './_04_pages/adaf';
import idealLocation from './_04_pages/ideal-location';
import bigTeam from './_04_pages/bigteam';
import deobfuscate from './_03_organisms/deobfuscate';
import offerContactForm from './_04_pages/offer-contact-form';
import guidedSearch from './_04_pages/guided-search';
import officeChooser from './_04_pages/office-chooser';
import onboarding from './_04_pages/organization-onboarding';
import spaceDetails from './_03_organisms/space-details/space-details';
import staticGoogleMap from './_03_organisms/page-details/static-google-map';
import pageSpaceContactForm from './_04_pages/page-space-contact-form';
import pageBrand from './_04_pages/page-brand';
import brandDetails from './_03_organisms/brand-details/brand-details';
import { pagination } from './_01_atoms/pagination';

// Load styles
import '../styles/_base.scss';
import '../styles/_vendor.scss';
import '../styles/_atoms.scss';
import '../styles/_molecules.scss';
import '../styles/_organisms.scss';
import '../styles/_pages.scss';
import { favoriteButtonLoader } from './_03_organisms/favoriteButtonLoader';

// Elements
version();
deviceDetect();

// Atoms usage
lazy();
loadAtoms();

// Molecules usage
banner();
favoriteBusHandler();
proposalBusHandler();
// a init que quand necessaire
sliderManager();
user();
deobfuscate();
accordions();
onboarding();

// Organisms usage
header();
window.addEventListener('load', stickyHeader);

if (document.fonts !== undefined) {
  document.fonts.ready.then(() => {
    document.body.classList.add('fonts-loaded');
  });
}

// Pages
if (document.querySelector('.menu-auth') !== null) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "connected-user-menu" */ './_03_organisms/header/connected-user-menu'
  );
}
if (document.querySelector('.search-menu') !== null) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "search-menu" */ './_03_organisms/header/search-menu'
  );
}
if (document.querySelector('.sales-menu') !== null) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "sales-menu" */ './_03_organisms/header/sales-menu'
  );
}
if (document.querySelector('.help-menu') !== null) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "help-menu" */ './_03_organisms/header/help-menu'
  );
}
profileManage(); // bundle

if (document.querySelector('#home')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "homepage" */ './_03_organisms/home'
  );
}

if (document.querySelector('.guide-article')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "guide" */ './_04_pages/guide'
  );
}

if (document.querySelector('.carousel')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "carousel" */ './_02_molecules/carousel'
  );
}

if (document.querySelector('#app-gallery')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "gallery" */ './_03_organisms/gallery'
  );
}

if (document.querySelector('.footer-columns')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "footer" */ './_03_organisms/footerFull'
  );
}

if (document.querySelector('#offer-statistics')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "statistics" */ './_03_organisms/offer/statistics'
  );
}
if (document.getElementById('holiday-banner')) {
  // eslint-disable-next-line import/extensions
  import(/* webpackChunkName: "banner" */ './_02_molecules/holiday-banner.js');
}

if (document.querySelector('.offer-card')) {
  // eslint-disable-next-line import/extensions
  import(/* webpackChunkName: "offer-card" */ './_02_molecules/components/offer-card');
}

contactUs(); // bundle
offerPage(); // bundle
createOffer(); // bundle
editOffer(); // bundle
vueInit();
offerFavorites(); // bundle
offerProposals(); // bundle
about(); // bundle
inbox(); // bundle
invoice(); // bundle
dealDashboard(); // bundle
leads(); // bundle
address(); // bundle
addressContact(); // bundle
addressDetails(); // bundle
adaf(); // bundle
idealLocation(); // bundle
bigTeam(); // bundle
offerContactForm();
guidedSearch(); // bundle
officeChooser(); // bundle
spaceDetails(); // bundle
pageBrand(); // bundle
pageSpaceContactForm(); // bundle
staticGoogleMap(); // bundle
brandDetails();
pagination();
favoriteButtonLoader();
